// noinspection JSUnusedGlobalSymbols

/**
 * This file was generated by the GraphQL Code Generator.
 * DO NOT EDIT.
 * @source: graphql-codegen/codegen.yml
 */

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any };
};

export type Address = {
  addressFirstLine?: Maybe<Scalars['String']['output']>;
  addressSecondLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isBilling?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isPayment?: Maybe<Scalars['Boolean']['output']>;
  isPoBox?: Maybe<Scalars['Boolean']['output']>;
  isShipping?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  addressFirstLine?: InputMaybe<Scalars['String']['input']>;
  addressSecondLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  isPoBox?: InputMaybe<Scalars['Boolean']['input']>;
  isShipping?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AdminActionRecord = {
  actor?: Maybe<User>;
  creditApplication?: Maybe<CreditApplication>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<AdminActionRecordType>;
  user?: Maybe<User>;
};

export enum AdminActionRecordType {
  AutoShippingPreference = 'AUTO_SHIPPING_PREFERENCE',
  CloseApplication = 'CLOSE_APPLICATION',
  CreditReview = 'CREDIT_REVIEW',
  DailyFileAddressChange = 'DAILY_FILE_ADDRESS_CHANGE',
  Email = 'EMAIL',
  ItemReview = 'ITEM_REVIEW',
  Other = 'OTHER',
  PackageWeight = 'PACKAGE_WEIGHT',
}

export enum CancellationType {
  CanceledHard = 'CANCELED_HARD',
  CanceledSoft = 'CANCELED_SOFT',
}

export type Card = {
  active?: Maybe<Scalars['Boolean']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  processor?: Maybe<CardProcessor>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum CardProcessor {
  I2C = 'I2C',
  Lithic = 'LITHIC',
}

export enum CollateralType {
  Cash = 'CASH',
  External = 'EXTERNAL',
  Item = 'ITEM',
  NoneSelected = 'NONE_SELECTED',
}

export type CreditApplication = {
  adminActionRecords?: Maybe<Array<AdminActionRecord>>;
  cardProcessor?: Maybe<CardProcessor>;
  creditChecks?: Maybe<Array<Maybe<CreditCheck>>>;
  creditOffers?: Maybe<Array<Maybe<CreditOffer>>>;
  docChecks?: Maybe<Array<Maybe<DocCheck>>>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated suspended is now a status on the status enum */
  isSuspended?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated pestoUser has been renamed to user */
  pestoUser?: Maybe<User>;
  shippingPriority?: Maybe<ShippingPriority>;
  status?: Maybe<CreditApplicationStatus>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verifyDoc?: Maybe<Scalars['Boolean']['output']>;
};

export enum CreditApplicationStatus {
  AppraisalInProgress = 'APPRAISAL_IN_PROGRESS',
  CanceledDupe = 'CANCELED_DUPE',
  CanceledHard = 'CANCELED_HARD',
  CanceledSoft = 'CANCELED_SOFT',
  CardOrdered = 'CARD_ORDERED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  CreditDenied = 'CREDIT_DENIED',
  CreditFreeze = 'CREDIT_FREEZE',
  FinInfoNeeded = 'FIN_INFO_NEEDED',
  InvalidState = 'INVALID_STATE',
  ItemUnderReview = 'ITEM_UNDER_REVIEW',
  ManualReview = 'MANUAL_REVIEW',
  NotPrequalified = 'NOT_PREQUALIFIED',
  OfferAccepted = 'OFFER_ACCEPTED',
  OfferDecisionNeeded = 'OFFER_DECISION_NEEDED',
  OfferRejected = 'OFFER_REJECTED',
  Prequalified = 'PREQUALIFIED',
  PrequalInfoGiven = 'PREQUAL_INFO_GIVEN',
  PrequalItemValued = 'PREQUAL_ITEM_VALUED',
  Shipped = 'SHIPPED',
  VerifyDoc = 'VERIFY_DOC',
}

export type CreditCheck = {
  abilityToPay?: Maybe<Scalars['Boolean']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['Boolean']['output']>;
  addressCorrelation?: Maybe<Scalars['Boolean']['output']>;
  addressStrict?: Maybe<Scalars['Boolean']['output']>;
  alertlist?: Maybe<Scalars['Boolean']['output']>;
  bankruptcy?: Maybe<Scalars['Boolean']['output']>;
  creditFreeze?: Maybe<Scalars['Boolean']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  deviceDuplicate?: Maybe<Scalars['Boolean']['output']>;
  deviceIdentity?: Maybe<Scalars['Boolean']['output']>;
  deviceOne?: Maybe<Scalars['Boolean']['output']>;
  deviceThree?: Maybe<Scalars['Boolean']['output']>;
  deviceTwo?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Boolean']['output']>;
  emailCorrelation?: Maybe<Scalars['Boolean']['output']>;
  emailStrict?: Maybe<Scalars['Boolean']['output']>;
  fraud?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  kyc?: Maybe<Scalars['Boolean']['output']>;
  mla?: Maybe<Scalars['Boolean']['output']>;
  noSsnMatch?: Maybe<Scalars['Boolean']['output']>;
  ofac?: Maybe<Scalars['Boolean']['output']>;
  pep?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
  phoneCorrelation?: Maybe<Scalars['Boolean']['output']>;
  phoneStrict?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonCodes?: Maybe<Array<Maybe<CreditCheckReasonCode>>>;
  socureIsNull?: Maybe<Scalars['Boolean']['output']>;
  synthetic?: Maybe<Scalars['Boolean']['output']>;
  syntheticStrict?: Maybe<Scalars['Boolean']['output']>;
  transunionIsNull?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  watchlist?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditCheckReasonCode = {
  category?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreditOffer = {
  active?: Maybe<Scalars['Boolean']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  decisionAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DocCheck = {
  active?: Maybe<Scalars['Boolean']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<User>;
  status?: Maybe<DocCheckStatus>;
};

export enum DocCheckStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  NotDone = 'NOT_DONE',
  Overridden = 'OVERRIDDEN',
}

export type ListCreditApplicationsResult = {
  creditApplications?: Maybe<Array<CreditApplication>>;
  pagination: PaginationDetails;
};

export type ListSecurityEventsResult = {
  pagination: PaginationDetails;
  securityEvents?: Maybe<Array<SecurityEvent>>;
};

export type ListUsersResult = {
  pagination: PaginationDetails;
  users?: Maybe<Array<User>>;
};

/** Monetary amounts are in cents; APR values are decimal strings (e.g. "2.6250"). */
export type OnboardNewUserInput = {
  addressInput: AddressInput;
  annualIncome: Scalars['Int']['input'];
  aprMargin: Scalars['String']['input'];
  cardProcessor?: InputMaybe<CardProcessor>;
  creditAmount: Scalars['Int']['input'];
  dob: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  initialApr: Scalars['String']['input'];
  initialBalance?: InputMaybe<Scalars['Int']['input']>;
  issueCard?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  originationDate: Scalars['String']['input'];
  partnerAccountNumber: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  promoEndDate?: InputMaybe<Scalars['String']['input']>;
  ssn: Scalars['String']['input'];
};

export type PaginationDetails = {
  hasNextPage: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  resultsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type Program = {
  cardProgram: Scalars['String']['output'];
  collateralType?: Maybe<CollateralType>;
  id: Scalars['ID']['output'];
  lithicCardProgramToken?: Maybe<Scalars['String']['output']>;
  lithicProductId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type ProgramInput = {
  cardProgram: Scalars['String']['input'];
  collateralType?: InputMaybe<CollateralType>;
  name: Scalars['String']['input'];
};

export type ProgramUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};

export type RetryPartnerKycResult = {
  creditApplication?: Maybe<CreditApplication>;
  kycDecision: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RootMutationType = {
  addAddress?: Maybe<User>;
  addDocCheck?: Maybe<CreditApplication>;
  /** Approve manual review (handles both regular credit checks and partner KYC) */
  approveManualReview?: Maybe<CreditApplication>;
  clearDocCheck?: Maybe<CreditApplication>;
  closeApplication?: Maybe<CreditApplication>;
  /**
   * Creates a new adminActionRecord for the logged in admin.
   *
   * If type is "OTHER" then a description is required and should contain an
   * explanation.
   */
  createActionRecordForCurrentAdmin?: Maybe<AdminActionRecord>;
  createProgram?: Maybe<Program>;
  createProgramUser?: Maybe<User>;
  /** Deny partner KYC manual review */
  denyPartnerKyc?: Maybe<CreditApplication>;
  /**
   * Boards a new user through the partner boarding path: creates the user and
   * credit application, runs KYC, and on approval publishes the user to
   * Starlink for ledger onboarding.
   */
  onboardNewUser?: Maybe<CreditApplication>;
  /** Retry partner KYC check - retrieves stored SSN and re-runs Oscilar */
  retryPartnerKyc?: Maybe<RetryPartnerKycResult>;
  reviewDocCheck?: Maybe<CreditApplication>;
  runHardCreditCheckMaybeCardOrder?: Maybe<CreditApplication>;
  runSoftCreditCheck?: Maybe<CreditApplication>;
  /** Complete credit application item_events */
  sendOffer?: Maybe<CreditApplication>;
  toggleDocVerification?: Maybe<CreditApplication>;
  updateProgram?: Maybe<Program>;
  updateUser?: Maybe<User>;
  /**
   * Withdraws (deactivates) active credit_offer sending the credit application.
   *
   * NOTE: An offer cannot be withdrawn if it is already inactive or if the user
   * has already accepted it.
   */
  withdrawOffer?: Maybe<CreditApplication>;
};

export type RootMutationTypeAddAddressArgs = {
  addressInput?: InputMaybe<AddressInput>;
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeAddDocCheckArgs = {
  creditApplicationId: Scalars['ID']['input'];
};

export type RootMutationTypeApproveManualReviewArgs = {
  creditApplicationId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeClearDocCheckArgs = {
  docCheckId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeCloseApplicationArgs = {
  affiliateContributed: Scalars['Boolean']['input'];
  bureauContributed: Scalars['Boolean']['input'];
  cancelReasons: Array<InputMaybe<Scalars['String']['input']>>;
  cancellationType: CancellationType;
  creditApplicationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  skipSendEmail: Scalars['Boolean']['input'];
};

export type RootMutationTypeCreateActionRecordForCurrentAdminArgs = {
  creditApplicationId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type: AdminActionRecordType;
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateProgramArgs = {
  programInput: ProgramInput;
};

export type RootMutationTypeCreateProgramUserArgs = {
  programUserInput: ProgramUserInput;
};

export type RootMutationTypeDenyPartnerKycArgs = {
  creditApplicationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeOnboardNewUserArgs = {
  input: OnboardNewUserInput;
};

export type RootMutationTypeRetryPartnerKycArgs = {
  creditApplicationId: Scalars['ID']['input'];
};

export type RootMutationTypeReviewDocCheckArgs = {
  docCheckId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  status: DocCheckStatus;
};

export type RootMutationTypeRunHardCreditCheckMaybeCardOrderArgs = {
  creditApplicationId: Scalars['ID']['input'];
};

export type RootMutationTypeRunSoftCreditCheckArgs = {
  creditApplicationId: Scalars['ID']['input'];
};

export type RootMutationTypeSendOfferArgs = {
  creditApplicationId: Scalars['ID']['input'];
};

export type RootMutationTypeToggleDocVerificationArgs = {
  creditApplicationId: Scalars['ID']['input'];
  require: Scalars['Boolean']['input'];
};

export type RootMutationTypeUpdateProgramArgs = {
  id: Scalars['ID']['input'];
  programInput: ProgramInput;
};

export type RootMutationTypeUpdateUserArgs = {
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeWithdrawOfferArgs = {
  creditOfferId: Scalars['ID']['input'];
};

export type RootQueryType = {
  card?: Maybe<Card>;
  /** Get an application by id */
  creditApplication?: Maybe<CreditApplication>;
  /** Get the currently signed-in user */
  currentUser?: Maybe<User>;
  listCreditApplications?: Maybe<ListCreditApplicationsResult>;
  listSecurityEvents?: Maybe<ListSecurityEventsResult>;
  listUsers?: Maybe<ListUsersResult>;
  program?: Maybe<Program>;
  programs?: Maybe<Array<Maybe<Program>>>;
  /** Get user by id */
  user?: Maybe<User>;
  /** Superadmin - Get a list of users */
  users?: Maybe<Array<Maybe<User>>>;
};

export type RootQueryTypeCardArgs = {
  cardId: Scalars['ID']['input'];
};

export type RootQueryTypeCreditApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootQueryTypeListCreditApplicationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  collateralTypeSelections?: InputMaybe<Array<InputMaybe<CollateralType>>>;
  collateralTypeSortDirection?: InputMaybe<SortDirection>;
  firstOf?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<CreditApplicationStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
  userAddressCitySearch?: InputMaybe<Scalars['String']['input']>;
  userAddressCitySortDirection?: InputMaybe<SortDirection>;
  userAddressStateSearch?: InputMaybe<Scalars['String']['input']>;
  userAddressStateSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userIsFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListSecurityEventsArgs = {
  descriptionSearch?: InputMaybe<Scalars['String']['input']>;
  descriptionSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  typeSelections?: InputMaybe<Array<InputMaybe<SecurityEventType>>>;
  typeSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userIdSearch?: InputMaybe<Scalars['String']['input']>;
  userIdSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListUsersArgs = {
  annualIncomeSortDirection?: InputMaybe<SortDirection>;
  dobSearch?: InputMaybe<Scalars['String']['input']>;
  dobSortDirection?: InputMaybe<SortDirection>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  firstNameSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSortDirection?: InputMaybe<SortDirection>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeProgramArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootQueryTypeUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SecurityEvent = {
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<SecurityEventType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum SecurityEventType {
  DifferentPaymentAddress = 'DIFFERENT_PAYMENT_ADDRESS',
  DifferentPaymentName = 'DIFFERENT_PAYMENT_NAME',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  DuplicatePhone = 'DUPLICATE_PHONE',
  DuplicateSsn = 'DUPLICATE_SSN',
}

export enum ShippingPriority {
  Expedited = 'EXPEDITED',
  Normal = 'NORMAL',
  Overnight = 'OVERNIGHT',
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type User = {
  /** @deprecated user billingAddress, shippingAddress, or addresses */
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  adminActionRecords?: Maybe<Array<Maybe<AdminActionRecord>>>;
  annualIncome?: Maybe<Scalars['Int']['output']>;
  billingAddress?: Maybe<Address>;
  creditApplications?: Maybe<Array<Maybe<CreditApplication>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isFriendsAndFam?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lithicAccountHolderToken?: Maybe<Scalars['String']['output']>;
  lithicAccountToken?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Admin actions performed by this user */
  performedAdminActionRecords?: Maybe<Array<AdminActionRecord>>;
  phone?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Program>;
  qrCode?: Maybe<Scalars['String']['output']>;
  quality?: Maybe<Scalars['Int']['output']>;
  shippingAddress?: Maybe<Address>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SmallUserFragmentFragment = {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  insertedAt?: any | null;
  program?: { id: string; collateralType?: CollateralType | null } | null;
};

export type DocCheckFragmentFragment = {
  id?: string | null;
  active?: boolean | null;
  reason?: string | null;
  status?: DocCheckStatus | null;
  documentId?: string | null;
  reviewedBy?: { id?: string | null; displayName?: string | null } | null;
};

export type CreditCheckFragmentFragment = {
  active?: boolean | null;
  insertedAt?: any | null;
  id?: string | null;
  pep?: boolean | null;
  mla?: boolean | null;
  creditFreeze?: boolean | null;
  abilityToPay?: boolean | null;
  bankruptcy?: boolean | null;
  addressStrict?: boolean | null;
  addressCorrelation?: boolean | null;
  phoneStrict?: boolean | null;
  phoneCorrelation?: boolean | null;
  emailStrict?: boolean | null;
  emailCorrelation?: boolean | null;
  syntheticStrict?: boolean | null;
  ofac?: boolean | null;
  noSsnMatch?: boolean | null;
  address?: boolean | null;
  fraud?: boolean | null;
  kyc?: boolean | null;
  synthetic?: boolean | null;
  email?: boolean | null;
  phone?: boolean | null;
  alertlist?: boolean | null;
  watchlist?: boolean | null;
  decision?: string | null;
  reason?: string | null;
  type?: string | null;
  deviceDuplicate?: boolean | null;
  deviceIdentity?: boolean | null;
  reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
};

export type CreditOfferFragmentFragment = {
  id?: string | null;
  active?: boolean | null;
  decision?: string | null;
  decisionAt?: any | null;
  reason?: string | null;
};

export type AddressFragmentFragment = {
  id?: string | null;
  addressFirstLine?: string | null;
  addressSecondLine?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  isPoBox?: boolean | null;
  isBilling?: boolean | null;
  isShipping?: boolean | null;
  isPayment?: boolean | null;
  isConfirmed?: boolean | null;
};

export type PaginationFragmentFragment = {
  totalRecords: number;
  resultsPerPage: number;
  pageNumber: number;
  hasNextPage: boolean;
  totalPages: number;
};

export type AdminActionRecordFragmentFragment = {
  id?: string | null;
  insertedAt?: any | null;
  description?: string | null;
  type?: AdminActionRecordType | null;
  actor?: { id?: string | null; displayName?: string | null } | null;
  user?: { id?: string | null; displayName?: string | null } | null;
};

export type BasicSecurityEventFragmentFragment = {
  id?: string | null;
  type?: SecurityEventType | null;
  description?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type CreditApplicationDetailsFragment = {
  id?: string | null;
  status?: CreditApplicationStatus | null;
  cardProcessor?: CardProcessor | null;
  updatedAt?: any | null;
  insertedAt?: any | null;
  verifyDoc?: boolean | null;
  docChecks?: Array<{
    id?: string | null;
    active?: boolean | null;
    reason?: string | null;
    status?: DocCheckStatus | null;
    documentId?: string | null;
    reviewedBy?: { id?: string | null; displayName?: string | null } | null;
  } | null> | null;
  pestoUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    insertedAt?: any | null;
    billingAddress?: {
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
      isPoBox?: boolean | null;
      isBilling?: boolean | null;
      isShipping?: boolean | null;
      isPayment?: boolean | null;
      isConfirmed?: boolean | null;
    } | null;
    shippingAddress?: {
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
      isPoBox?: boolean | null;
      isBilling?: boolean | null;
      isShipping?: boolean | null;
      isPayment?: boolean | null;
      isConfirmed?: boolean | null;
    } | null;
    address?: {
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
      isPoBox?: boolean | null;
      isBilling?: boolean | null;
      isShipping?: boolean | null;
      isPayment?: boolean | null;
      isConfirmed?: boolean | null;
    } | null;
    program?: { id: string; collateralType?: CollateralType | null } | null;
  } | null;
  adminActionRecords?: Array<{
    id?: string | null;
    insertedAt?: any | null;
    description?: string | null;
    type?: AdminActionRecordType | null;
    actor?: { id?: string | null; displayName?: string | null } | null;
    user?: { id?: string | null; displayName?: string | null } | null;
  }> | null;
  creditChecks?: Array<{
    active?: boolean | null;
    insertedAt?: any | null;
    id?: string | null;
    pep?: boolean | null;
    mla?: boolean | null;
    creditFreeze?: boolean | null;
    abilityToPay?: boolean | null;
    bankruptcy?: boolean | null;
    addressStrict?: boolean | null;
    addressCorrelation?: boolean | null;
    phoneStrict?: boolean | null;
    phoneCorrelation?: boolean | null;
    emailStrict?: boolean | null;
    emailCorrelation?: boolean | null;
    syntheticStrict?: boolean | null;
    ofac?: boolean | null;
    noSsnMatch?: boolean | null;
    address?: boolean | null;
    fraud?: boolean | null;
    kyc?: boolean | null;
    synthetic?: boolean | null;
    email?: boolean | null;
    phone?: boolean | null;
    alertlist?: boolean | null;
    watchlist?: boolean | null;
    decision?: string | null;
    reason?: string | null;
    type?: string | null;
    deviceDuplicate?: boolean | null;
    deviceIdentity?: boolean | null;
    reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
  } | null> | null;
  creditOffers?: Array<{
    id?: string | null;
    active?: boolean | null;
    decision?: string | null;
    decisionAt?: any | null;
    reason?: string | null;
  } | null> | null;
};

export type SecurityEventFragmentFragment = {
  id?: string | null;
  type?: SecurityEventType | null;
  description?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  user?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    insertedAt?: any | null;
    program?: { id: string; collateralType?: CollateralType | null } | null;
  } | null;
};

export type AddAddressMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  addressInput?: InputMaybe<AddressInput>;
}>;

export type AddAddressMutation = { addAddress?: { id?: string | null } | null };

export type ApproveManualReviewMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type ApproveManualReviewMutation = {
  approveManualReview?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export type CloseApplicationMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
  cancellationType: CancellationType;
  cancelReasons: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  affiliateContributed: Scalars['Boolean']['input'];
  bureauContributed: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
  skipSendEmail?: Scalars['Boolean']['input'];
}>;

export type CloseApplicationMutation = {
  closeApplication?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export type CreateActionRecordForCurrentAdminMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  creditApplicationId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  action: AdminActionRecordType;
}>;

export type CreateActionRecordForCurrentAdminMutation = {
  createActionRecordForCurrentAdmin?: {
    id?: string | null;
    type?: AdminActionRecordType | null;
    description?: string | null;
    insertedAt?: any | null;
    actor?: { id?: string | null; displayName?: string | null } | null;
    user?: { id?: string | null; displayName?: string | null } | null;
  } | null;
};

export type CreateProgramMutationVariables = Exact<{
  input: ProgramInput;
}>;

export type CreateProgramMutation = {
  createProgram?: { id: string; name: string; cardProgram: string; collateralType?: CollateralType | null } | null;
};

export type CreateProgramUserMutationVariables = Exact<{
  input: ProgramUserInput;
}>;

export type CreateProgramUserMutation = {
  createProgramUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
  } | null;
};

export type DenyPartnerKycMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;

export type DenyPartnerKycMutation = {
  denyPartnerKyc?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export type OnboardNewUserMutationVariables = Exact<{
  input: OnboardNewUserInput;
}>;

export type OnboardNewUserMutation = {
  onboardNewUser?: { id?: string | null; status?: CreditApplicationStatus | null } | null;
};

export type RetryPartnerKycMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;

export type RetryPartnerKycMutation = {
  retryPartnerKyc?: {
    kycDecision: string;
    message?: string | null;
    creditApplication?: {
      id?: string | null;
      status?: CreditApplicationStatus | null;
      cardProcessor?: CardProcessor | null;
      updatedAt?: any | null;
      insertedAt?: any | null;
      verifyDoc?: boolean | null;
      docChecks?: Array<{
        id?: string | null;
        active?: boolean | null;
        reason?: string | null;
        status?: DocCheckStatus | null;
        documentId?: string | null;
        reviewedBy?: { id?: string | null; displayName?: string | null } | null;
      } | null> | null;
      pestoUser?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        insertedAt?: any | null;
        billingAddress?: {
          id?: string | null;
          addressFirstLine?: string | null;
          addressSecondLine?: string | null;
          city?: string | null;
          state?: string | null;
          zip?: string | null;
          isPoBox?: boolean | null;
          isBilling?: boolean | null;
          isShipping?: boolean | null;
          isPayment?: boolean | null;
          isConfirmed?: boolean | null;
        } | null;
        shippingAddress?: {
          id?: string | null;
          addressFirstLine?: string | null;
          addressSecondLine?: string | null;
          city?: string | null;
          state?: string | null;
          zip?: string | null;
          isPoBox?: boolean | null;
          isBilling?: boolean | null;
          isShipping?: boolean | null;
          isPayment?: boolean | null;
          isConfirmed?: boolean | null;
        } | null;
        address?: {
          id?: string | null;
          addressFirstLine?: string | null;
          addressSecondLine?: string | null;
          city?: string | null;
          state?: string | null;
          zip?: string | null;
          isPoBox?: boolean | null;
          isBilling?: boolean | null;
          isShipping?: boolean | null;
          isPayment?: boolean | null;
          isConfirmed?: boolean | null;
        } | null;
        program?: { id: string; collateralType?: CollateralType | null } | null;
      } | null;
      adminActionRecords?: Array<{
        id?: string | null;
        insertedAt?: any | null;
        description?: string | null;
        type?: AdminActionRecordType | null;
        actor?: { id?: string | null; displayName?: string | null } | null;
        user?: { id?: string | null; displayName?: string | null } | null;
      }> | null;
      creditChecks?: Array<{
        active?: boolean | null;
        insertedAt?: any | null;
        id?: string | null;
        pep?: boolean | null;
        mla?: boolean | null;
        creditFreeze?: boolean | null;
        abilityToPay?: boolean | null;
        bankruptcy?: boolean | null;
        addressStrict?: boolean | null;
        addressCorrelation?: boolean | null;
        phoneStrict?: boolean | null;
        phoneCorrelation?: boolean | null;
        emailStrict?: boolean | null;
        emailCorrelation?: boolean | null;
        syntheticStrict?: boolean | null;
        ofac?: boolean | null;
        noSsnMatch?: boolean | null;
        address?: boolean | null;
        fraud?: boolean | null;
        kyc?: boolean | null;
        synthetic?: boolean | null;
        email?: boolean | null;
        phone?: boolean | null;
        alertlist?: boolean | null;
        watchlist?: boolean | null;
        decision?: string | null;
        reason?: string | null;
        type?: string | null;
        deviceDuplicate?: boolean | null;
        deviceIdentity?: boolean | null;
        reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
      } | null> | null;
      creditOffers?: Array<{
        id?: string | null;
        active?: boolean | null;
        decision?: string | null;
        decisionAt?: any | null;
        reason?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SendOfferMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;

export type SendOfferMutation = {
  sendOffer?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export type UpdateProgramMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ProgramInput;
}>;

export type UpdateProgramMutation = {
  updateProgram?: { id: string; name: string; cardProgram: string; collateralType?: CollateralType | null } | null;
};

export type UpdatePartnerUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;

export type UpdatePartnerUserMutation = {
  updateUser?: { id?: string | null; firstName?: string | null; lastName?: string | null } | null;
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateUserMutation = {
  updateUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    annualIncome?: number | null;
    isFriendsAndFam?: boolean | null;
  } | null;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  currentUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    insertedAt?: any | null;
    program?: { id: string; collateralType?: CollateralType | null } | null;
  } | null;
};

export type GetProgramByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProgramByIdQuery = {
  program?: {
    id: string;
    name: string;
    cardProgram: string;
    collateralType?: CollateralType | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    users?: Array<{
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
    } | null> | null;
  } | null;
};

export type GetPartnerUserByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPartnerUserByIdQuery = {
  user?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
  } | null;
};

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetUserByIdQuery = {
  user?: {
    id?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    annualIncome?: number | null;
    insertedAt?: any | null;
    isFriendsAndFam?: boolean | null;
    quality?: number | null;
    lithicAccountHolderToken?: string | null;
    lithicAccountToken?: string | null;
    creditApplications?: Array<{ id?: string | null; status?: CreditApplicationStatus | null } | null> | null;
    adminActionRecords?: Array<{
      id?: string | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      insertedAt?: any | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    billingAddress?: {
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
    shippingAddress?: {
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      zip?: string | null;
      state?: string | null;
    } | null;
  } | null;
};

export type ListCreditApplicationsQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<CreditApplicationStatus>> | InputMaybe<CreditApplicationStatus>>;
  collateralTypeSelections?: InputMaybe<Array<InputMaybe<CollateralType>> | InputMaybe<CollateralType>>;
  collateralTypeSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userAddressCitySortDirection?: InputMaybe<SortDirection>;
  userAddressCitySearch?: InputMaybe<Scalars['String']['input']>;
  userAddressStateSortDirection?: InputMaybe<SortDirection>;
  userAddressStateSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userIsFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  firstOf?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListCreditApplicationsQuery = {
  listCreditApplications?: {
    creditApplications?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      status?: CreditApplicationStatus | null;
      pestoUser?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phone?: string | null;
        email?: string | null;
        isFriendsAndFam?: boolean | null;
        billingAddress?: { id?: string | null; city?: string | null; state?: string | null } | null;
      } | null;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type ListProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type ListProgramsQuery = { programs?: Array<{ id: string; name: string; cardProgram: string } | null> | null };

export type ListSecurityEventsQueryVariables = Exact<{
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  typeSortDirection?: InputMaybe<SortDirection>;
  typeSelections?: InputMaybe<Array<InputMaybe<SecurityEventType>> | InputMaybe<SecurityEventType>>;
  descriptionSortDirection?: InputMaybe<SortDirection>;
  descriptionSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userIdSortDirection?: InputMaybe<SortDirection>;
  userIdSearch?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListSecurityEventsQuery = {
  listSecurityEvents?: {
    securityEvents?: Array<{
      id?: string | null;
      type?: SecurityEventType | null;
      description?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      user?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        insertedAt?: any | null;
        program?: { id: string; collateralType?: CollateralType | null } | null;
      } | null;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type ListUsersQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  firstNameSortDirection?: InputMaybe<SortDirection>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSortDirection?: InputMaybe<SortDirection>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSortDirection?: InputMaybe<SortDirection>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  dobSortDirection?: InputMaybe<SortDirection>;
  dobSearch?: InputMaybe<Scalars['String']['input']>;
  annualIncomeSortDirection?: InputMaybe<SortDirection>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListUsersQuery = {
  listUsers?: {
    users?: Array<{
      id?: string | null;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phone?: string | null;
      dob?: string | null;
      annualIncome?: number | null;
      insertedAt?: any | null;
      isFriendsAndFam?: boolean | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        isPoBox?: boolean | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type PaymentStatsQueryVariables = Exact<{
  statusSelections?: InputMaybe<Array<InputMaybe<CreditApplicationStatus>> | InputMaybe<CreditApplicationStatus>>;
}>;

export type PaymentStatsQuery = { listCreditApplications?: { pagination: { totalRecords: number } } | null };

export type StatsQueryVariables = Exact<{
  statusSelections?: InputMaybe<Array<InputMaybe<CreditApplicationStatus>> | InputMaybe<CreditApplicationStatus>>;
  collateralTypeSelections?: InputMaybe<Array<InputMaybe<CollateralType>> | InputMaybe<CollateralType>>;
}>;

export type StatsQuery = { listCreditApplications?: { pagination: { totalRecords: number } } | null };

export type AddDocCheckMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;

export type AddDocCheckMutation = {
  addDocCheck?: {
    id?: string | null;
    updatedAt?: any | null;
    verifyDoc?: boolean | null;
    status?: CreditApplicationStatus | null;
  } | null;
};

export type ReviewDocCheckMutationVariables = Exact<{
  docCheckId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  status: DocCheckStatus;
}>;

export type ReviewDocCheckMutation = {
  reviewDocCheck?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
  } | null;
};

export type RunHardCreditCheckMaybeCardOrderMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;

export type RunHardCreditCheckMaybeCardOrderMutation = {
  runHardCreditCheckMaybeCardOrder?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export type RunSoftCreditCheckMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;

export type RunSoftCreditCheckMutation = {
  runSoftCreditCheck?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export type ToggleDocVerificationMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
  require: Scalars['Boolean']['input'];
}>;

export type ToggleDocVerificationMutation = {
  toggleDocVerification?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    verifyDoc?: boolean | null;
  } | null;
};

export type GetCreditApplicationByIdQueryVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;

export type GetCreditApplicationByIdQuery = {
  creditApplication?: {
    id?: string | null;
    status?: CreditApplicationStatus | null;
    cardProcessor?: CardProcessor | null;
    updatedAt?: any | null;
    insertedAt?: any | null;
    verifyDoc?: boolean | null;
    docChecks?: Array<{
      id?: string | null;
      active?: boolean | null;
      reason?: string | null;
      status?: DocCheckStatus | null;
      documentId?: string | null;
      reviewedBy?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
    pestoUser?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      insertedAt?: any | null;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      address?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isPayment?: boolean | null;
        isConfirmed?: boolean | null;
      } | null;
      program?: { id: string; collateralType?: CollateralType | null } | null;
    } | null;
    adminActionRecords?: Array<{
      id?: string | null;
      insertedAt?: any | null;
      description?: string | null;
      type?: AdminActionRecordType | null;
      actor?: { id?: string | null; displayName?: string | null } | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    }> | null;
    creditChecks?: Array<{
      active?: boolean | null;
      insertedAt?: any | null;
      id?: string | null;
      pep?: boolean | null;
      mla?: boolean | null;
      creditFreeze?: boolean | null;
      abilityToPay?: boolean | null;
      bankruptcy?: boolean | null;
      addressStrict?: boolean | null;
      addressCorrelation?: boolean | null;
      phoneStrict?: boolean | null;
      phoneCorrelation?: boolean | null;
      emailStrict?: boolean | null;
      emailCorrelation?: boolean | null;
      syntheticStrict?: boolean | null;
      ofac?: boolean | null;
      noSsnMatch?: boolean | null;
      address?: boolean | null;
      fraud?: boolean | null;
      kyc?: boolean | null;
      synthetic?: boolean | null;
      email?: boolean | null;
      phone?: boolean | null;
      alertlist?: boolean | null;
      watchlist?: boolean | null;
      decision?: string | null;
      reason?: string | null;
      type?: string | null;
      deviceDuplicate?: boolean | null;
      deviceIdentity?: boolean | null;
      reasonCodes?: Array<{ category?: string | null; codes?: Array<string | null> | null } | null> | null;
    } | null> | null;
    creditOffers?: Array<{
      id?: string | null;
      active?: boolean | null;
      decision?: string | null;
      decisionAt?: any | null;
      reason?: string | null;
    } | null> | null;
  } | null;
};

export const PaginationFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment PaginationFragment on PaginationDetails {
    totalRecords
    resultsPerPage
    pageNumber
    hasNextPage
    totalPages
  }
`;
export const DocCheckFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment DocCheckFragment on DocCheck {
    id
    active
    reason
    status
    documentId
    reviewedBy {
      id
      displayName
    }
  }
`;
export const SmallUserFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmallUserFragment on User {
    id
    firstName
    lastName
    email
    phone
    insertedAt
    program {
      id
      collateralType
    }
  }
`;
export const AddressFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AddressFragment on Address {
    id
    addressFirstLine
    addressSecondLine
    city
    state
    zip
    isPoBox
    isBilling
    isShipping
    isPayment
    isConfirmed
  }
`;
export const AdminActionRecordFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminActionRecordFragment on AdminActionRecord {
    id
    insertedAt
    description
    type
    actor {
      id
      displayName
    }
    user {
      id
      displayName
    }
  }
`;
export const CreditCheckFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditCheckFragment on CreditCheck {
    active
    insertedAt
    id
    pep
    mla
    creditFreeze
    abilityToPay
    bankruptcy
    addressStrict
    addressCorrelation
    phoneStrict
    phoneCorrelation
    emailStrict
    emailCorrelation
    syntheticStrict
    ofac
    noSsnMatch
    address
    fraud
    kyc
    synthetic
    email
    phone
    alertlist
    watchlist
    decision
    reason
    type
    deviceDuplicate
    deviceIdentity
    reasonCodes {
      category
      codes
    }
  }
`;
export const CreditOfferFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditOfferFragment on CreditOffer {
    id
    active
    decision
    decisionAt
    reason
  }
`;
export const CreditApplicationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditApplicationDetails on CreditApplication {
    id
    status
    cardProcessor
    updatedAt
    insertedAt
    verifyDoc
    docChecks {
      ...DocCheckFragment
    }
    pestoUser {
      ...SmallUserFragment
      billingAddress {
        ...AddressFragment
      }
      shippingAddress {
        ...AddressFragment
      }
      address {
        ...AddressFragment
      }
    }
    adminActionRecords {
      ...AdminActionRecordFragment
    }
    creditChecks {
      ...CreditCheckFragment
    }
    creditOffers {
      ...CreditOfferFragment
    }
  }
  ${DocCheckFragmentFragmentDoc}
  ${SmallUserFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${AdminActionRecordFragmentFragmentDoc}
  ${CreditCheckFragmentFragmentDoc}
  ${CreditOfferFragmentFragmentDoc}
`;
export const BasicSecurityEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicSecurityEventFragment on SecurityEvent {
    id
    type
    description
    insertedAt
    updatedAt
  }
`;
export const SecurityEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SecurityEventFragment on SecurityEvent {
    ...BasicSecurityEventFragment
    user {
      ...SmallUserFragment
    }
  }
  ${BasicSecurityEventFragmentFragmentDoc}
  ${SmallUserFragmentFragmentDoc}
`;
export const AddAddressDocument = /*#__PURE__*/ gql`
  mutation addAddress($userId: ID!, $addressInput: AddressInput) {
    addAddress(userId: $userId, addressInput: $addressInput) {
      id
    }
  }
`;
export type AddAddressMutationFn = Apollo.MutationFunction<AddAddressMutation, AddAddressMutationVariables>;

/**
 * __useAddAddressMutation__
 *
 * To run a mutation, you first call `useAddAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAddressMutation, { data, loading, error }] = useAddAddressMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useAddAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<AddAddressMutation, AddAddressMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddAddressMutation, AddAddressMutationVariables>(AddAddressDocument, options);
}
export type AddAddressMutationHookResult = ReturnType<typeof useAddAddressMutation>;
export type AddAddressMutationResult = Apollo.MutationResult<AddAddressMutation>;
export type AddAddressMutationOptions = Apollo.BaseMutationOptions<AddAddressMutation, AddAddressMutationVariables>;
export const ApproveManualReviewDocument = /*#__PURE__*/ gql`
  mutation approveManualReview($creditApplicationId: ID!, $reason: String) {
    approveManualReview(creditApplicationId: $creditApplicationId, reason: $reason) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type ApproveManualReviewMutationFn = Apollo.MutationFunction<
  ApproveManualReviewMutation,
  ApproveManualReviewMutationVariables
>;

/**
 * __useApproveManualReviewMutation__
 *
 * To run a mutation, you first call `useApproveManualReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveManualReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveManualReviewMutation, { data, loading, error }] = useApproveManualReviewMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useApproveManualReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<ApproveManualReviewMutation, ApproveManualReviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApproveManualReviewMutation, ApproveManualReviewMutationVariables>(
    ApproveManualReviewDocument,
    options,
  );
}
export type ApproveManualReviewMutationHookResult = ReturnType<typeof useApproveManualReviewMutation>;
export type ApproveManualReviewMutationResult = Apollo.MutationResult<ApproveManualReviewMutation>;
export type ApproveManualReviewMutationOptions = Apollo.BaseMutationOptions<
  ApproveManualReviewMutation,
  ApproveManualReviewMutationVariables
>;
export const CloseApplicationDocument = /*#__PURE__*/ gql`
  mutation closeApplication(
    $creditApplicationId: ID!
    $cancellationType: CancellationType!
    $cancelReasons: [String]!
    $affiliateContributed: Boolean!
    $bureauContributed: Boolean!
    $reason: String!
    $skipSendEmail: Boolean! = false
  ) {
    closeApplication(
      creditApplicationId: $creditApplicationId
      cancellationType: $cancellationType
      cancelReasons: $cancelReasons
      affiliateContributed: $affiliateContributed
      bureauContributed: $bureauContributed
      reason: $reason
      skipSendEmail: $skipSendEmail
    ) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type CloseApplicationMutationFn = Apollo.MutationFunction<
  CloseApplicationMutation,
  CloseApplicationMutationVariables
>;

/**
 * __useCloseApplicationMutation__
 *
 * To run a mutation, you first call `useCloseApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeApplicationMutation, { data, loading, error }] = useCloseApplicationMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      cancellationType: // value for 'cancellationType'
 *      cancelReasons: // value for 'cancelReasons'
 *      affiliateContributed: // value for 'affiliateContributed'
 *      bureauContributed: // value for 'bureauContributed'
 *      reason: // value for 'reason'
 *      skipSendEmail: // value for 'skipSendEmail'
 *   },
 * });
 */
export function useCloseApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<CloseApplicationMutation, CloseApplicationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseApplicationMutation, CloseApplicationMutationVariables>(
    CloseApplicationDocument,
    options,
  );
}
export type CloseApplicationMutationHookResult = ReturnType<typeof useCloseApplicationMutation>;
export type CloseApplicationMutationResult = Apollo.MutationResult<CloseApplicationMutation>;
export type CloseApplicationMutationOptions = Apollo.BaseMutationOptions<
  CloseApplicationMutation,
  CloseApplicationMutationVariables
>;
export const CreateActionRecordForCurrentAdminDocument = /*#__PURE__*/ gql`
  mutation createActionRecordForCurrentAdmin(
    $userId: ID!
    $creditApplicationId: ID!
    $description: String
    $action: AdminActionRecordType!
  ) {
    createActionRecordForCurrentAdmin(
      userId: $userId
      creditApplicationId: $creditApplicationId
      description: $description
      type: $action
    ) {
      id
      type
      description
      actor {
        id
        displayName
      }
      user {
        id
        displayName
      }
      insertedAt
    }
  }
`;
export type CreateActionRecordForCurrentAdminMutationFn = Apollo.MutationFunction<
  CreateActionRecordForCurrentAdminMutation,
  CreateActionRecordForCurrentAdminMutationVariables
>;

/**
 * __useCreateActionRecordForCurrentAdminMutation__
 *
 * To run a mutation, you first call `useCreateActionRecordForCurrentAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionRecordForCurrentAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionRecordForCurrentAdminMutation, { data, loading, error }] = useCreateActionRecordForCurrentAdminMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      creditApplicationId: // value for 'creditApplicationId'
 *      description: // value for 'description'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useCreateActionRecordForCurrentAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateActionRecordForCurrentAdminMutation,
    CreateActionRecordForCurrentAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateActionRecordForCurrentAdminMutation,
    CreateActionRecordForCurrentAdminMutationVariables
  >(CreateActionRecordForCurrentAdminDocument, options);
}
export type CreateActionRecordForCurrentAdminMutationHookResult = ReturnType<
  typeof useCreateActionRecordForCurrentAdminMutation
>;
export type CreateActionRecordForCurrentAdminMutationResult =
  Apollo.MutationResult<CreateActionRecordForCurrentAdminMutation>;
export type CreateActionRecordForCurrentAdminMutationOptions = Apollo.BaseMutationOptions<
  CreateActionRecordForCurrentAdminMutation,
  CreateActionRecordForCurrentAdminMutationVariables
>;
export const CreateProgramDocument = /*#__PURE__*/ gql`
  mutation CreateProgram($input: ProgramInput!) {
    createProgram(programInput: $input) {
      id
      name
      cardProgram
      collateralType
    }
  }
`;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;

/**
 * __useCreateProgramMutation__
 *
 * To run a mutation, you first call `useCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramMutation, { data, loading, error }] = useCreateProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, options);
}
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationResult = Apollo.MutationResult<CreateProgramMutation>;
export type CreateProgramMutationOptions = Apollo.BaseMutationOptions<
  CreateProgramMutation,
  CreateProgramMutationVariables
>;
export const CreateProgramUserDocument = /*#__PURE__*/ gql`
  mutation CreateProgramUser($input: ProgramUserInput!) {
    createProgramUser(programUserInput: $input) {
      id
      firstName
      lastName
      email
    }
  }
`;
export type CreateProgramUserMutationFn = Apollo.MutationFunction<
  CreateProgramUserMutation,
  CreateProgramUserMutationVariables
>;

/**
 * __useCreateProgramUserMutation__
 *
 * To run a mutation, you first call `useCreateProgramUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramUserMutation, { data, loading, error }] = useCreateProgramUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProgramUserMutation, CreateProgramUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProgramUserMutation, CreateProgramUserMutationVariables>(
    CreateProgramUserDocument,
    options,
  );
}
export type CreateProgramUserMutationHookResult = ReturnType<typeof useCreateProgramUserMutation>;
export type CreateProgramUserMutationResult = Apollo.MutationResult<CreateProgramUserMutation>;
export type CreateProgramUserMutationOptions = Apollo.BaseMutationOptions<
  CreateProgramUserMutation,
  CreateProgramUserMutationVariables
>;
export const DenyPartnerKycDocument = /*#__PURE__*/ gql`
  mutation denyPartnerKyc($creditApplicationId: ID!, $reason: String!) {
    denyPartnerKyc(creditApplicationId: $creditApplicationId, reason: $reason) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type DenyPartnerKycMutationFn = Apollo.MutationFunction<DenyPartnerKycMutation, DenyPartnerKycMutationVariables>;

/**
 * __useDenyPartnerKycMutation__
 *
 * To run a mutation, you first call `useDenyPartnerKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyPartnerKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyPartnerKycMutation, { data, loading, error }] = useDenyPartnerKycMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyPartnerKycMutation(
  baseOptions?: Apollo.MutationHookOptions<DenyPartnerKycMutation, DenyPartnerKycMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DenyPartnerKycMutation, DenyPartnerKycMutationVariables>(DenyPartnerKycDocument, options);
}
export type DenyPartnerKycMutationHookResult = ReturnType<typeof useDenyPartnerKycMutation>;
export type DenyPartnerKycMutationResult = Apollo.MutationResult<DenyPartnerKycMutation>;
export type DenyPartnerKycMutationOptions = Apollo.BaseMutationOptions<
  DenyPartnerKycMutation,
  DenyPartnerKycMutationVariables
>;
export const OnboardNewUserDocument = /*#__PURE__*/ gql`
  mutation onboardNewUser($input: OnboardNewUserInput!) {
    onboardNewUser(input: $input) {
      id
      status
    }
  }
`;
export type OnboardNewUserMutationFn = Apollo.MutationFunction<OnboardNewUserMutation, OnboardNewUserMutationVariables>;

/**
 * __useOnboardNewUserMutation__
 *
 * To run a mutation, you first call `useOnboardNewUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardNewUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardNewUserMutation, { data, loading, error }] = useOnboardNewUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardNewUserMutation(
  baseOptions?: Apollo.MutationHookOptions<OnboardNewUserMutation, OnboardNewUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OnboardNewUserMutation, OnboardNewUserMutationVariables>(OnboardNewUserDocument, options);
}
export type OnboardNewUserMutationHookResult = ReturnType<typeof useOnboardNewUserMutation>;
export type OnboardNewUserMutationResult = Apollo.MutationResult<OnboardNewUserMutation>;
export type OnboardNewUserMutationOptions = Apollo.BaseMutationOptions<
  OnboardNewUserMutation,
  OnboardNewUserMutationVariables
>;
export const RetryPartnerKycDocument = /*#__PURE__*/ gql`
  mutation retryPartnerKyc($creditApplicationId: ID!) {
    retryPartnerKyc(creditApplicationId: $creditApplicationId) {
      creditApplication {
        id
        ...CreditApplicationDetails
      }
      kycDecision
      message
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type RetryPartnerKycMutationFn = Apollo.MutationFunction<
  RetryPartnerKycMutation,
  RetryPartnerKycMutationVariables
>;

/**
 * __useRetryPartnerKycMutation__
 *
 * To run a mutation, you first call `useRetryPartnerKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPartnerKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPartnerKycMutation, { data, loading, error }] = useRetryPartnerKycMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useRetryPartnerKycMutation(
  baseOptions?: Apollo.MutationHookOptions<RetryPartnerKycMutation, RetryPartnerKycMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RetryPartnerKycMutation, RetryPartnerKycMutationVariables>(
    RetryPartnerKycDocument,
    options,
  );
}
export type RetryPartnerKycMutationHookResult = ReturnType<typeof useRetryPartnerKycMutation>;
export type RetryPartnerKycMutationResult = Apollo.MutationResult<RetryPartnerKycMutation>;
export type RetryPartnerKycMutationOptions = Apollo.BaseMutationOptions<
  RetryPartnerKycMutation,
  RetryPartnerKycMutationVariables
>;
export const SendOfferDocument = /*#__PURE__*/ gql`
  mutation sendOffer($creditApplicationId: ID!) {
    sendOffer(creditApplicationId: $creditApplicationId) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type SendOfferMutationFn = Apollo.MutationFunction<SendOfferMutation, SendOfferMutationVariables>;

/**
 * __useSendOfferMutation__
 *
 * To run a mutation, you first call `useSendOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOfferMutation, { data, loading, error }] = useSendOfferMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useSendOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<SendOfferMutation, SendOfferMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendOfferMutation, SendOfferMutationVariables>(SendOfferDocument, options);
}
export type SendOfferMutationHookResult = ReturnType<typeof useSendOfferMutation>;
export type SendOfferMutationResult = Apollo.MutationResult<SendOfferMutation>;
export type SendOfferMutationOptions = Apollo.BaseMutationOptions<SendOfferMutation, SendOfferMutationVariables>;
export const UpdateProgramDocument = /*#__PURE__*/ gql`
  mutation UpdateProgram($id: ID!, $input: ProgramInput!) {
    updateProgram(id: $id, programInput: $input) {
      id
      name
      cardProgram
      collateralType
    }
  }
`;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
}
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<
  UpdateProgramMutation,
  UpdateProgramMutationVariables
>;
export const UpdatePartnerUserDocument = /*#__PURE__*/ gql`
  mutation UpdatePartnerUser($id: ID!, $firstName: String!, $lastName: String!) {
    updateUser(userId: $id, firstName: $firstName, lastName: $lastName) {
      id
      firstName
      lastName
    }
  }
`;
export type UpdatePartnerUserMutationFn = Apollo.MutationFunction<
  UpdatePartnerUserMutation,
  UpdatePartnerUserMutationVariables
>;

/**
 * __useUpdatePartnerUserMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerUserMutation, { data, loading, error }] = useUpdatePartnerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdatePartnerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables>(
    UpdatePartnerUserDocument,
    options,
  );
}
export type UpdatePartnerUserMutationHookResult = ReturnType<typeof useUpdatePartnerUserMutation>;
export type UpdatePartnerUserMutationResult = Apollo.MutationResult<UpdatePartnerUserMutation>;
export type UpdatePartnerUserMutationOptions = Apollo.BaseMutationOptions<
  UpdatePartnerUserMutation,
  UpdatePartnerUserMutationVariables
>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
  mutation updateUser(
    $userId: ID!
    $firstName: String
    $middleName: String
    $lastName: String
    $phone: String
    $isFriendsAndFam: Boolean
    $annualIncome: Int
    $dob: String
  ) {
    updateUser(
      userId: $userId
      firstName: $firstName
      middleName: $middleName
      lastName: $lastName
      phone: $phone
      isFriendsAndFam: $isFriendsAndFam
      annualIncome: $annualIncome
      dob: $dob
    ) {
      id
      firstName
      lastName
      middleName
      phone
      dob
      annualIncome
      isFriendsAndFam
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      middleName: // value for 'middleName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      isFriendsAndFam: // value for 'isFriendsAndFam'
 *      annualIncome: // value for 'annualIncome'
 *      dob: // value for 'dob'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CurrentUserDocument = /*#__PURE__*/ gql`
  query currentUser {
    currentUser {
      ...SmallUserFragment
    }
  }
  ${SmallUserFragmentFragmentDoc}
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetProgramByIdDocument = /*#__PURE__*/ gql`
  query GetProgramById($id: ID!) {
    program(id: $id) {
      id
      name
      cardProgram
      collateralType
      lithicCardProgramToken
      lithicProductId
      users {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

/**
 * __useGetProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables> &
    ({ variables: GetProgramByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
}
export function useGetProgramByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
}
// @ts-ignore
export function useGetProgramByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetProgramByIdQuery, GetProgramByIdQueryVariables>;
export function useGetProgramByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetProgramByIdQuery | undefined, GetProgramByIdQueryVariables>;
export function useGetProgramByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
}
export type GetProgramByIdQueryHookResult = ReturnType<typeof useGetProgramByIdQuery>;
export type GetProgramByIdLazyQueryHookResult = ReturnType<typeof useGetProgramByIdLazyQuery>;
export type GetProgramByIdSuspenseQueryHookResult = ReturnType<typeof useGetProgramByIdSuspenseQuery>;
export type GetProgramByIdQueryResult = Apollo.QueryResult<GetProgramByIdQuery, GetProgramByIdQueryVariables>;
export const GetPartnerUserByIdDocument = /*#__PURE__*/ gql`
  query GetPartnerUserById($id: ID!) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      phone
    }
  }
`;

/**
 * __useGetPartnerUserByIdQuery__
 *
 * To run a query within a React component, call `useGetPartnerUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartnerUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables> &
    ({ variables: GetPartnerUserByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>(
    GetPartnerUserByIdDocument,
    options,
  );
}
export function useGetPartnerUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>(
    GetPartnerUserByIdDocument,
    options,
  );
}
// @ts-ignore
export function useGetPartnerUserByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>;
export function useGetPartnerUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPartnerUserByIdQuery | undefined, GetPartnerUserByIdQueryVariables>;
export function useGetPartnerUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPartnerUserByIdQuery, GetPartnerUserByIdQueryVariables>(
    GetPartnerUserByIdDocument,
    options,
  );
}
export type GetPartnerUserByIdQueryHookResult = ReturnType<typeof useGetPartnerUserByIdQuery>;
export type GetPartnerUserByIdLazyQueryHookResult = ReturnType<typeof useGetPartnerUserByIdLazyQuery>;
export type GetPartnerUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetPartnerUserByIdSuspenseQuery>;
export type GetPartnerUserByIdQueryResult = Apollo.QueryResult<
  GetPartnerUserByIdQuery,
  GetPartnerUserByIdQueryVariables
>;
export const GetUserByIdDocument = /*#__PURE__*/ gql`
  query getUserById($userId: ID!) {
    user(id: $userId) {
      id
      email
      firstName
      lastName
      middleName
      phone
      dob
      annualIncome
      insertedAt
      isFriendsAndFam
      quality
      lithicAccountHolderToken
      lithicAccountToken
      creditApplications {
        id
        status
      }
      adminActionRecords {
        id
        description
        type
        actor {
          id
          displayName
        }
        user {
          id
          displayName
        }
        insertedAt
      }
      billingAddress {
        id
        addressFirstLine
        addressSecondLine
        city
        zip
        state
      }
      shippingAddress {
        id
        addressFirstLine
        addressSecondLine
        city
        zip
        state
      }
    }
  }
`;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> &
    ({ variables: GetUserByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
}
export function useGetUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
}
// @ts-ignore
export function useGetUserByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserByIdQuery | undefined, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
}
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const ListCreditApplicationsDocument = /*#__PURE__*/ gql`
  query listCreditApplications(
    $idSortDirection: SortDirection
    $idSearch: String
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [CreditApplicationStatus]
    $collateralTypeSelections: [CollateralType]
    $collateralTypeSortDirection: SortDirection
    $userFirstNameSortDirection: SortDirection
    $userFirstNameSearch: String
    $userLastNameSortDirection: SortDirection
    $userLastNameSearch: String
    $userAddressCitySortDirection: SortDirection
    $userAddressCitySearch: String
    $userAddressStateSortDirection: SortDirection
    $userAddressStateSearch: String
    $userEmailSortDirection: SortDirection
    $userEmailSearch: String
    $userIsFriendsAndFam: Boolean
    $firstOf: Boolean
    $from: Date
    $to: Date
    $resultsPerPage: Int
    $pageNumber: Int
    $paginationDetailsOnly: Boolean
    $fullResults: Boolean
  ) {
    listCreditApplications(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      collateralTypeSelections: $collateralTypeSelections
      collateralTypeSortDirection: $collateralTypeSortDirection
      userFirstNameSortDirection: $userFirstNameSortDirection
      userFirstNameSearch: $userFirstNameSearch
      userLastNameSortDirection: $userLastNameSortDirection
      userLastNameSearch: $userLastNameSearch
      userAddressCitySortDirection: $userAddressCitySortDirection
      userAddressCitySearch: $userAddressCitySearch
      userAddressStateSortDirection: $userAddressStateSortDirection
      userAddressStateSearch: $userAddressStateSearch
      userEmailSearch: $userEmailSearch
      userEmailSortDirection: $userEmailSortDirection
      userIsFriendsAndFam: $userIsFriendsAndFam
      firstOf: $firstOf
      from: $from
      to: $to
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
      paginationDetailsOnly: $paginationDetailsOnly
      fullResults: $fullResults
    ) {
      creditApplications {
        id
        insertedAt
        status
        pestoUser {
          id
          firstName
          lastName
          phone
          email
          isFriendsAndFam
          billingAddress {
            id
            city
            state
          }
        }
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListCreditApplicationsQuery__
 *
 * To run a query within a React component, call `useListCreditApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCreditApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCreditApplicationsQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      collateralTypeSelections: // value for 'collateralTypeSelections'
 *      collateralTypeSortDirection: // value for 'collateralTypeSortDirection'
 *      userFirstNameSortDirection: // value for 'userFirstNameSortDirection'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userLastNameSortDirection: // value for 'userLastNameSortDirection'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userAddressCitySortDirection: // value for 'userAddressCitySortDirection'
 *      userAddressCitySearch: // value for 'userAddressCitySearch'
 *      userAddressStateSortDirection: // value for 'userAddressStateSortDirection'
 *      userAddressStateSearch: // value for 'userAddressStateSearch'
 *      userEmailSortDirection: // value for 'userEmailSortDirection'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      userIsFriendsAndFam: // value for 'userIsFriendsAndFam'
 *      firstOf: // value for 'firstOf'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      fullResults: // value for 'fullResults'
 *   },
 * });
 */
export function useListCreditApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>(
    ListCreditApplicationsDocument,
    options,
  );
}
export function useListCreditApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>(
    ListCreditApplicationsDocument,
    options,
  );
}
// @ts-ignore
export function useListCreditApplicationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>;
export function useListCreditApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCreditApplicationsQuery | undefined, ListCreditApplicationsQueryVariables>;
export function useListCreditApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCreditApplicationsQuery, ListCreditApplicationsQueryVariables>(
    ListCreditApplicationsDocument,
    options,
  );
}
export type ListCreditApplicationsQueryHookResult = ReturnType<typeof useListCreditApplicationsQuery>;
export type ListCreditApplicationsLazyQueryHookResult = ReturnType<typeof useListCreditApplicationsLazyQuery>;
export type ListCreditApplicationsSuspenseQueryHookResult = ReturnType<typeof useListCreditApplicationsSuspenseQuery>;
export type ListCreditApplicationsQueryResult = Apollo.QueryResult<
  ListCreditApplicationsQuery,
  ListCreditApplicationsQueryVariables
>;
export const ListProgramsDocument = /*#__PURE__*/ gql`
  query listPrograms {
    programs {
      id
      name
      cardProgram
    }
  }
`;

/**
 * __useListProgramsQuery__
 *
 * To run a query within a React component, call `useListProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
}
export function useListProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
}
// @ts-ignore
export function useListProgramsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListProgramsQuery, ListProgramsQueryVariables>;
export function useListProgramsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListProgramsQuery | undefined, ListProgramsQueryVariables>;
export function useListProgramsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
}
export type ListProgramsQueryHookResult = ReturnType<typeof useListProgramsQuery>;
export type ListProgramsLazyQueryHookResult = ReturnType<typeof useListProgramsLazyQuery>;
export type ListProgramsSuspenseQueryHookResult = ReturnType<typeof useListProgramsSuspenseQuery>;
export type ListProgramsQueryResult = Apollo.QueryResult<ListProgramsQuery, ListProgramsQueryVariables>;
export const ListSecurityEventsDocument = /*#__PURE__*/ gql`
  query listSecurityEvents(
    $insertedAtSortDirection: SortDirection
    $typeSortDirection: SortDirection
    $typeSelections: [SecurityEventType]
    $descriptionSortDirection: SortDirection
    $descriptionSearch: String
    $userFirstNameSortDirection: SortDirection
    $userFirstNameSearch: String
    $userLastNameSortDirection: SortDirection
    $userLastNameSearch: String
    $userEmailSortDirection: SortDirection
    $userEmailSearch: String
    $userIdSortDirection: SortDirection
    $userIdSearch: String
    $from: Date
    $to: Date
    $paginationDetailsOnly: Boolean
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listSecurityEvents(
      insertedAtSortDirection: $insertedAtSortDirection
      typeSortDirection: $typeSortDirection
      typeSelections: $typeSelections
      descriptionSortDirection: $descriptionSortDirection
      descriptionSearch: $descriptionSearch
      userFirstNameSortDirection: $userFirstNameSortDirection
      userFirstNameSearch: $userFirstNameSearch
      userLastNameSortDirection: $userLastNameSortDirection
      userLastNameSearch: $userLastNameSearch
      userEmailSortDirection: $userEmailSortDirection
      userEmailSearch: $userEmailSearch
      userIdSortDirection: $userIdSortDirection
      userIdSearch: $userIdSearch
      from: $from
      to: $to
      paginationDetailsOnly: $paginationDetailsOnly
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      securityEvents {
        ...SecurityEventFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${SecurityEventFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListSecurityEventsQuery__
 *
 * To run a query within a React component, call `useListSecurityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSecurityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSecurityEventsQuery({
 *   variables: {
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      typeSortDirection: // value for 'typeSortDirection'
 *      typeSelections: // value for 'typeSelections'
 *      descriptionSortDirection: // value for 'descriptionSortDirection'
 *      descriptionSearch: // value for 'descriptionSearch'
 *      userFirstNameSortDirection: // value for 'userFirstNameSortDirection'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userLastNameSortDirection: // value for 'userLastNameSortDirection'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userEmailSortDirection: // value for 'userEmailSortDirection'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      userIdSortDirection: // value for 'userIdSortDirection'
 *      userIdSearch: // value for 'userIdSearch'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListSecurityEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>(
    ListSecurityEventsDocument,
    options,
  );
}
export function useListSecurityEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>(
    ListSecurityEventsDocument,
    options,
  );
}
// @ts-ignore
export function useListSecurityEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>;
export function useListSecurityEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListSecurityEventsQuery | undefined, ListSecurityEventsQueryVariables>;
export function useListSecurityEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSecurityEventsQuery, ListSecurityEventsQueryVariables>(
    ListSecurityEventsDocument,
    options,
  );
}
export type ListSecurityEventsQueryHookResult = ReturnType<typeof useListSecurityEventsQuery>;
export type ListSecurityEventsLazyQueryHookResult = ReturnType<typeof useListSecurityEventsLazyQuery>;
export type ListSecurityEventsSuspenseQueryHookResult = ReturnType<typeof useListSecurityEventsSuspenseQuery>;
export type ListSecurityEventsQueryResult = Apollo.QueryResult<
  ListSecurityEventsQuery,
  ListSecurityEventsQueryVariables
>;
export const ListUsersDocument = /*#__PURE__*/ gql`
  query listUsers(
    $idSortDirection: SortDirection
    $idSearch: String
    $firstNameSortDirection: SortDirection
    $firstNameSearch: String
    $lastNameSortDirection: SortDirection
    $lastNameSearch: String
    $phoneSortDirection: SortDirection
    $phoneSearch: String
    $dobSortDirection: SortDirection
    $dobSearch: String
    $annualIncomeSortDirection: SortDirection
    $isFriendsAndFam: Boolean
    $insertedAtSortDirection: SortDirection
    $from: Date
    $to: Date
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listUsers(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      firstNameSortDirection: $firstNameSortDirection
      firstNameSearch: $firstNameSearch
      lastNameSortDirection: $lastNameSortDirection
      lastNameSearch: $lastNameSearch
      phoneSortDirection: $phoneSortDirection
      phoneSearch: $phoneSearch
      dobSortDirection: $dobSortDirection
      dobSearch: $dobSearch
      annualIncomeSortDirection: $annualIncomeSortDirection
      isFriendsAndFam: $isFriendsAndFam
      insertedAtSortDirection: $insertedAtSortDirection
      from: $from
      to: $to
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      users {
        id
        email
        firstName
        lastName
        phone
        dob
        annualIncome
        insertedAt
        isFriendsAndFam
        address {
          id
          addressFirstLine
          addressSecondLine
          city
          isPoBox
          zip
          state
        }
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      firstNameSortDirection: // value for 'firstNameSortDirection'
 *      firstNameSearch: // value for 'firstNameSearch'
 *      lastNameSortDirection: // value for 'lastNameSortDirection'
 *      lastNameSearch: // value for 'lastNameSearch'
 *      phoneSortDirection: // value for 'phoneSortDirection'
 *      phoneSearch: // value for 'phoneSearch'
 *      dobSortDirection: // value for 'dobSortDirection'
 *      dobSearch: // value for 'dobSearch'
 *      annualIncomeSortDirection: // value for 'annualIncomeSortDirection'
 *      isFriendsAndFam: // value for 'isFriendsAndFam'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
export function useListUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
// @ts-ignore
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListUsersQuery, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListUsersQuery | undefined, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const PaymentStatsDocument = /*#__PURE__*/ gql`
  query paymentStats($statusSelections: [CreditApplicationStatus]) {
    listCreditApplications(
      paginationDetailsOnly: true
      statusSelections: $statusSelections
      userIsFriendsAndFam: false
      collateralTypeSelections: [CASH]
    ) {
      pagination {
        totalRecords
      }
    }
  }
`;

/**
 * __usePaymentStatsQuery__
 *
 * To run a query within a React component, call `usePaymentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentStatsQuery({
 *   variables: {
 *      statusSelections: // value for 'statusSelections'
 *   },
 * });
 */
export function usePaymentStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentStatsQuery, PaymentStatsQueryVariables>(PaymentStatsDocument, options);
}
export function usePaymentStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaymentStatsQuery, PaymentStatsQueryVariables>(PaymentStatsDocument, options);
}
// @ts-ignore
export function usePaymentStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>,
): Apollo.UseSuspenseQueryResult<PaymentStatsQuery, PaymentStatsQueryVariables>;
export function usePaymentStatsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>,
): Apollo.UseSuspenseQueryResult<PaymentStatsQuery | undefined, PaymentStatsQueryVariables>;
export function usePaymentStatsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PaymentStatsQuery, PaymentStatsQueryVariables>(PaymentStatsDocument, options);
}
export type PaymentStatsQueryHookResult = ReturnType<typeof usePaymentStatsQuery>;
export type PaymentStatsLazyQueryHookResult = ReturnType<typeof usePaymentStatsLazyQuery>;
export type PaymentStatsSuspenseQueryHookResult = ReturnType<typeof usePaymentStatsSuspenseQuery>;
export type PaymentStatsQueryResult = Apollo.QueryResult<PaymentStatsQuery, PaymentStatsQueryVariables>;
export const StatsDocument = /*#__PURE__*/ gql`
  query stats($statusSelections: [CreditApplicationStatus], $collateralTypeSelections: [CollateralType]) {
    listCreditApplications(
      paginationDetailsOnly: true
      statusSelections: $statusSelections
      collateralTypeSelections: $collateralTypeSelections
      userIsFriendsAndFam: false
    ) {
      pagination {
        totalRecords
      }
    }
  }
`;

/**
 * __useStatsQuery__
 *
 * To run a query within a React component, call `useStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsQuery({
 *   variables: {
 *      statusSelections: // value for 'statusSelections'
 *      collateralTypeSelections: // value for 'collateralTypeSelections'
 *   },
 * });
 */
export function useStatsQuery(baseOptions?: Apollo.QueryHookOptions<StatsQuery, StatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
}
export function useStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsQuery, StatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
}
// @ts-ignore
export function useStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<StatsQuery, StatsQueryVariables>,
): Apollo.UseSuspenseQueryResult<StatsQuery, StatsQueryVariables>;
export function useStatsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatsQuery, StatsQueryVariables>,
): Apollo.UseSuspenseQueryResult<StatsQuery | undefined, StatsQueryVariables>;
export function useStatsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatsQuery, StatsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
}
export type StatsQueryHookResult = ReturnType<typeof useStatsQuery>;
export type StatsLazyQueryHookResult = ReturnType<typeof useStatsLazyQuery>;
export type StatsSuspenseQueryHookResult = ReturnType<typeof useStatsSuspenseQuery>;
export type StatsQueryResult = Apollo.QueryResult<StatsQuery, StatsQueryVariables>;
export const AddDocCheckDocument = /*#__PURE__*/ gql`
  mutation addDocCheck($creditApplicationId: ID!) {
    addDocCheck(creditApplicationId: $creditApplicationId) {
      id
      updatedAt
      verifyDoc
      status
    }
  }
`;
export type AddDocCheckMutationFn = Apollo.MutationFunction<AddDocCheckMutation, AddDocCheckMutationVariables>;

/**
 * __useAddDocCheckMutation__
 *
 * To run a mutation, you first call `useAddDocCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocCheckMutation, { data, loading, error }] = useAddDocCheckMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useAddDocCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<AddDocCheckMutation, AddDocCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddDocCheckMutation, AddDocCheckMutationVariables>(AddDocCheckDocument, options);
}
export type AddDocCheckMutationHookResult = ReturnType<typeof useAddDocCheckMutation>;
export type AddDocCheckMutationResult = Apollo.MutationResult<AddDocCheckMutation>;
export type AddDocCheckMutationOptions = Apollo.BaseMutationOptions<AddDocCheckMutation, AddDocCheckMutationVariables>;
export const ReviewDocCheckDocument = /*#__PURE__*/ gql`
  mutation reviewDocCheck($docCheckId: ID!, $reason: String!, $status: DocCheckStatus!) {
    reviewDocCheck(docCheckId: $docCheckId, reason: $reason, status: $status) {
      id
      status
      verifyDoc
      docChecks {
        id
        active
        reason
        status
        documentId
        reviewedBy {
          id
          displayName
        }
      }
    }
  }
`;
export type ReviewDocCheckMutationFn = Apollo.MutationFunction<ReviewDocCheckMutation, ReviewDocCheckMutationVariables>;

/**
 * __useReviewDocCheckMutation__
 *
 * To run a mutation, you first call `useReviewDocCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewDocCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewDocCheckMutation, { data, loading, error }] = useReviewDocCheckMutation({
 *   variables: {
 *      docCheckId: // value for 'docCheckId'
 *      reason: // value for 'reason'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useReviewDocCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewDocCheckMutation, ReviewDocCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReviewDocCheckMutation, ReviewDocCheckMutationVariables>(ReviewDocCheckDocument, options);
}
export type ReviewDocCheckMutationHookResult = ReturnType<typeof useReviewDocCheckMutation>;
export type ReviewDocCheckMutationResult = Apollo.MutationResult<ReviewDocCheckMutation>;
export type ReviewDocCheckMutationOptions = Apollo.BaseMutationOptions<
  ReviewDocCheckMutation,
  ReviewDocCheckMutationVariables
>;
export const RunHardCreditCheckMaybeCardOrderDocument = /*#__PURE__*/ gql`
  mutation runHardCreditCheckMaybeCardOrder($creditApplicationId: ID!) {
    runHardCreditCheckMaybeCardOrder(creditApplicationId: $creditApplicationId) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type RunHardCreditCheckMaybeCardOrderMutationFn = Apollo.MutationFunction<
  RunHardCreditCheckMaybeCardOrderMutation,
  RunHardCreditCheckMaybeCardOrderMutationVariables
>;

/**
 * __useRunHardCreditCheckMaybeCardOrderMutation__
 *
 * To run a mutation, you first call `useRunHardCreditCheckMaybeCardOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunHardCreditCheckMaybeCardOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runHardCreditCheckMaybeCardOrderMutation, { data, loading, error }] = useRunHardCreditCheckMaybeCardOrderMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useRunHardCreditCheckMaybeCardOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunHardCreditCheckMaybeCardOrderMutation,
    RunHardCreditCheckMaybeCardOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RunHardCreditCheckMaybeCardOrderMutation,
    RunHardCreditCheckMaybeCardOrderMutationVariables
  >(RunHardCreditCheckMaybeCardOrderDocument, options);
}
export type RunHardCreditCheckMaybeCardOrderMutationHookResult = ReturnType<
  typeof useRunHardCreditCheckMaybeCardOrderMutation
>;
export type RunHardCreditCheckMaybeCardOrderMutationResult =
  Apollo.MutationResult<RunHardCreditCheckMaybeCardOrderMutation>;
export type RunHardCreditCheckMaybeCardOrderMutationOptions = Apollo.BaseMutationOptions<
  RunHardCreditCheckMaybeCardOrderMutation,
  RunHardCreditCheckMaybeCardOrderMutationVariables
>;
export const RunSoftCreditCheckDocument = /*#__PURE__*/ gql`
  mutation runSoftCreditCheck($creditApplicationId: ID!) {
    runSoftCreditCheck(creditApplicationId: $creditApplicationId) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;
export type RunSoftCreditCheckMutationFn = Apollo.MutationFunction<
  RunSoftCreditCheckMutation,
  RunSoftCreditCheckMutationVariables
>;

/**
 * __useRunSoftCreditCheckMutation__
 *
 * To run a mutation, you first call `useRunSoftCreditCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunSoftCreditCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runSoftCreditCheckMutation, { data, loading, error }] = useRunSoftCreditCheckMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useRunSoftCreditCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<RunSoftCreditCheckMutation, RunSoftCreditCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunSoftCreditCheckMutation, RunSoftCreditCheckMutationVariables>(
    RunSoftCreditCheckDocument,
    options,
  );
}
export type RunSoftCreditCheckMutationHookResult = ReturnType<typeof useRunSoftCreditCheckMutation>;
export type RunSoftCreditCheckMutationResult = Apollo.MutationResult<RunSoftCreditCheckMutation>;
export type RunSoftCreditCheckMutationOptions = Apollo.BaseMutationOptions<
  RunSoftCreditCheckMutation,
  RunSoftCreditCheckMutationVariables
>;
export const ToggleDocVerificationDocument = /*#__PURE__*/ gql`
  mutation toggleDocVerification($creditApplicationId: ID!, $require: Boolean!) {
    toggleDocVerification(creditApplicationId: $creditApplicationId, require: $require) {
      id
      status
      verifyDoc
    }
  }
`;
export type ToggleDocVerificationMutationFn = Apollo.MutationFunction<
  ToggleDocVerificationMutation,
  ToggleDocVerificationMutationVariables
>;

/**
 * __useToggleDocVerificationMutation__
 *
 * To run a mutation, you first call `useToggleDocVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDocVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDocVerificationMutation, { data, loading, error }] = useToggleDocVerificationMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      require: // value for 'require'
 *   },
 * });
 */
export function useToggleDocVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<ToggleDocVerificationMutation, ToggleDocVerificationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ToggleDocVerificationMutation, ToggleDocVerificationMutationVariables>(
    ToggleDocVerificationDocument,
    options,
  );
}
export type ToggleDocVerificationMutationHookResult = ReturnType<typeof useToggleDocVerificationMutation>;
export type ToggleDocVerificationMutationResult = Apollo.MutationResult<ToggleDocVerificationMutation>;
export type ToggleDocVerificationMutationOptions = Apollo.BaseMutationOptions<
  ToggleDocVerificationMutation,
  ToggleDocVerificationMutationVariables
>;
export const GetCreditApplicationByIdDocument = /*#__PURE__*/ gql`
  query getCreditApplicationById($creditApplicationId: ID!) {
    creditApplication(id: $creditApplicationId) {
      id
      ...CreditApplicationDetails
    }
  }
  ${CreditApplicationDetailsFragmentDoc}
`;

/**
 * __useGetCreditApplicationByIdQuery__
 *
 * To run a query within a React component, call `useGetCreditApplicationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplicationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplicationByIdQuery({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetCreditApplicationByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables> &
    ({ variables: GetCreditApplicationByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>(
    GetCreditApplicationByIdDocument,
    options,
  );
}
export function useGetCreditApplicationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>(
    GetCreditApplicationByIdDocument,
    options,
  );
}
// @ts-ignore
export function useGetCreditApplicationByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>;
export function useGetCreditApplicationByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCreditApplicationByIdQuery | undefined, GetCreditApplicationByIdQueryVariables>;
export function useGetCreditApplicationByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCreditApplicationByIdQuery, GetCreditApplicationByIdQueryVariables>(
    GetCreditApplicationByIdDocument,
    options,
  );
}
export type GetCreditApplicationByIdQueryHookResult = ReturnType<typeof useGetCreditApplicationByIdQuery>;
export type GetCreditApplicationByIdLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationByIdLazyQuery>;
export type GetCreditApplicationByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCreditApplicationByIdSuspenseQuery
>;
export type GetCreditApplicationByIdQueryResult = Apollo.QueryResult<
  GetCreditApplicationByIdQuery,
  GetCreditApplicationByIdQueryVariables
>;
